export default {"src":"https://kroemtech.ch//_next/static/media/dathaScy_logo_white.e015422c.svg","height":72,"width":299,"blurWidth":0,"blurHeight":0};